export const RECORD_MOCKUP = {
  header: "Monthly Budget \u203a Madison \u00b7 AE 3 \u00b7 WISC \u00b7 Local Sales - Direct \u00b7 Mar 2027",
  recordId: "AE 3 \u00b7 WISC \u00b7 21-00-2100 \u00b7 Mar 2027",
  fields: [
    ["Budget owner", "AE 3 (Madison)"],
    ["Market", "Madison"],
    ["Station", "WISC"],
    ["Account code", "2100"],
    ["Category / group", "Local \u00b7 Broadcast"],
    ["Revenue month", "2027-03-01"],
    ["Budget", "$52,000"],
  ],
  financials: [
    ["Booked (cash)", "$31,400", false],
    ["Pending (raw)", "$18,000", false],
    ["Pending (weighted)", "$9,800", false],
    ["Projected", "$41,200", false],
    ["Variance", "-$10,800 (-20.8%)", true],
    ["New business booked", "$6,200", false],
  ],
  assocs: [
    { title: "Billing records", count: "3", rows: [["WO order \u00b7 Mar 2027", "$31,400"]] },
    { title: "Forecasted Revenue", count: "2 deals", rows: [["Spring auto promo \u00b7 Negotiation", "$10,000 \u2192 $7,000"], ["Health system Q1-Q2 \u00b7 Proposal", "$8,000 \u2192 $3,200"]] },
  ],
};

export const DASHBOARDS = {
  ae: {
    title: "Dashboard \u203a AE pacing \u00b7 AE 3 (Madison)",
    chips: [["Owner", "AE 3"], ["Market", "Madison"], ["Year", "2027"], ["Cash only", "Yes"]],
    tiles: [["Budget YTD", "$298,000"], ["Booked", "$214,600"], ["Weighted pending", "$51,300"], ["Projected vs budget", "-10.8%", "neg"]],
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    bud: [48, 46, 52, 50, 50, 52],
    proj: [50, 47, 41, 44, 46, 38],
    booked: [50, 47, 31, 27, 22, 14],
    tt: "By category group",
    cols: ["Group", "Budget", "Projected", "Var."],
    rows: [["Broadcast", "$196,000", "$171,400", "-12.6%"], ["Digital", "$102,000", "$94,500", "-7.4%"]],
  },
  mk: {
    title: "Dashboard \u203a Market pacing \u00b7 Madison",
    chips: [["Market", "Madison"], ["AE", "All"], ["Station", "All"], ["Category", "All"]],
    tiles: [["Budget YTD", "$2.31M"], ["Booked", "$1.62M"], ["Weighted pending", "$0.44M"], ["Projected vs budget", "-8.2%", "neg"]],
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    bud: [380, 372, 398, 390, 386, 384],
    proj: [392, 380, 360, 352, 350, 343],
    booked: [392, 380, 302, 268, 214, 166],
    tt: "By AE (incl. open seats and Paids)",
    cols: ["Owner", "Budget", "Projected", "Var."],
    rows: [["AE 1", "$412,000", "$398,700", "-3.2%"], ["AE 3", "$298,000", "$265,900", "-10.8%"], ["Open Seat 1", "$186,000", "$61,200", "-67.1%"], ["Paid Programming", "$94,000", "$97,300", "+3.5%"]],
  },
  co: {
    title: "Dashboard \u203a Corporate pacing \u00b7 All markets",
    chips: [["Market", "All"], ["Group", "All"], ["Year", "2027"], ["Cash only", "Yes"]],
    tiles: [["Budget YTD", "$7.40M"], ["Booked", "$5.21M"], ["Weighted pending", "$1.38M"], ["Projected vs budget", "-10.9%", "neg"]],
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    bud: [1210, 1180, 1260, 1240, 1250, 1260],
    proj: [1240, 1190, 1130, 1100, 1060, 1000],
    booked: [1240, 1190, 960, 830, 640, 430],
    tt: "By category group",
    cols: ["Group", "Budget", "Projected", "Var."],
    rows: [["Broadcast", "$5.12M", "$4.58M", "-10.5%"], ["Digital", "$2.04M", "$1.80M", "-11.8%"], ["Magazine", "$0.24M", "$0.21M", "-12.5%"]],
  },
};
